import React from 'react';

const Straighten = ({ className }) => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="7.40038" y="0.707052" width="9.58568" height="9.58568" transform="rotate(44.2884 7.40038 0.707052)" stroke="white"/>
      <path d="M3.5293 10.6839V10.6839C5.05812 9.17394 7.5263 9.20518 9.01641 10.7533L9.70427 11.468" stroke="white" strokeLinecap="round"/>
      <circle cx="8.38083" cy="6.61618" r="1.32321" fill="white"/>
    </svg>
  )
}

export default Straighten;